module.exports = __webpack_public_path__ + "img/title-3.72c32e42.png";